import { useCallback, useEffect, useState } from "react";
import moment, { Moment } from "moment";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { LECTURE_PATH, LECTURE_SUBPATH } from "routes";
import useLecture from "hooks/lecture/useLecture";
import { axiosFile } from "utils/axiosFile";
import { useUserContext } from "contexts/UserContext";
import { USER_TYPE } from "utils/enums";
import { startLecture as startMemberLecture } from "api/member/rests";
import {
  startLecture as startClinicLecture,
  restartLecture as restartClinicLecture,
} from "api/clinic/rests";

const DutyLecturePlayPage = () => {
  const { userType } = useUserContext();
  const navigate = useNavigate();
  const [startTime, setStartTime] = useState<Moment>(moment());
  const { courseId } = useParams();
  const [params] = useSearchParams();
  const collectFlag = params.get("collectFlag");
  const retry = params.get("retry");
  const { lecture_list, lecture_type } = useLecture(Number(courseId)) || {
    lecture_list: [
      {
        lecture_id: 0,
        name: "",
        video_id: "",
        description: "",
        material_download_link: "",
        material_download_filename: "",
      },
    ],
  };

  const startLecture = useCallback(async () => {
    const lecture = lecture_list[0];
    if (lecture && lecture_type) {
      userType === USER_TYPE.개인회원
        ? await startMemberLecture(
            lecture_type,
            lecture.lecture_id,
            !!collectFlag
          )
        : retry
        ? await restartClinicLecture(
            lecture_type,
            lecture.lecture_id,
            !!collectFlag
          )
        : await startClinicLecture(
            lecture_type,
            lecture.lecture_id,
            !!collectFlag
          );
    }
  }, [userType, courseId, lecture_type, retry]);

  useEffect(() => {
    (async () => {
      try {
        startLecture();
      } catch (e) {}
    })();
  }, [lecture_type, courseId, userType, retry]);

  useEffect(() => {
    setStartTime(moment());
  }, []);

  return (
    <section className="edu-detail">
      <div className="detail-group">
        <div className="tit-box">
          <div>
            <div className="back-btn" onClick={() => navigate(-1)}>
              <i className="ic ic-back"></i>
            </div>
          </div>
          <div className="tit-txt">{lecture_list[0].name}</div>
          {lecture_list[0]?.material_download_link && (
            <button
              className="material-link"
              onClick={() =>
                axiosFile(
                  lecture_list[0].material_download_link as string,
                  lecture_list[0].material_download_filename as string
                )
              }
            >
              강의 자료 🗂
            </button>
          )}
        </div>

        <div className="video-box" style={{ height: "538px" }}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${lecture_list[0].video_id}`}
            title="YouTube video player"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={false}
          ></iframe>
        </div>

        <div className="con-box">{lecture_list[0].description}</div>
      </div>

      <div className="view-menu-box">
        <article className="lecture-menu-box">
          <a
            href={`${LECTURE_PATH}/${
              LECTURE_SUBPATH.DUTY
            }/${courseId}/personnel?timestamp=${startTime.format("X")}${
              collectFlag ? "&collectFlag=1" : ""
            }${retry ? "&retry=1" : ""}`}
            className="lecture-menu-btn on"
          >
            <span className="txt">수강완료 하기</span>
            <i className="ic ic-lock"></i>
          </a>
        </article>
      </div>
    </section>
  );
};

export default DutyLecturePlayPage;
